import React, { createContext, useState, useEffect, useContext } from "react";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../utility/firebaseConfig";
import { get, post } from "../utility/fetchWeb";
import { NotificationsContext } from "./NotificationsContext";
import { useIncomingCall } from "./IncomingCallContext";

export const FirebaseMessagingContext = createContext();

export const FirebaseMessagingProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showIncomingCallModal, setShowIncomingCallModal] = useState(false);
  const { refreshNotifications } = useContext(NotificationsContext) || {};


  // Inside a component that listens for a call signal
const { showIncomingCall } = useIncomingCall();


const getAgoraDetails = async (callDetails) => {
  console.log("Fetching Agora details for call:", callDetails);
  try {
    const res = await get(`/posts/generate-new-token?channelName=${callDetails.channel}&uid=${Number(sessionStorage.getItem("userId"))}`);
    if (res && res.token) {
      // Pass all necessary info to the incoming call context
      showIncomingCall({
        appId: res.appId,
        channel: res.channelName,
        token: res.token,
        uid: sessionStorage.getItem("userId"),
        callerName: callDetails.callerName, // Pass the caller's name along
      });
    } else {
      console.error("Failed to fetch Agora token");
    }
  } catch (error) {
    console.error("Error fetching Agora token:", error);
  }
};


  const handleIncomingCall = (payload) => {
    if (payload.data) {
      // Assuming you send channel and callerName in the data payload
      getAgoraDetails({ 
        channel: payload.data.channelName,
        callerName: payload.data.callerName 
      });
    }
  };

  useEffect(() => {
    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    const getAndSendToken = async () => {
      try {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
        });

        if (token) {
          console.log("FCM Token obtained:", token);

          // Send token to backend
          await post("/Auth/update-device-token", {
            userId: sessionStorage.getItem("userId"),
            deviceToken: token,
          });

          console.log("Device token sent successfully");
        } else {
          console.warn("No device token available");
        }
      } catch (err) {
        console.error("Error getting/sending FCM token:", err);
      }
    };

    getAndSendToken();

    // Foreground message listener
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      setMessages((prev) => [payload, ...prev]);
      setUnreadCount((prev) => prev + 1);
      if(payload?.notification?.title === "Incoming Call"){
          handleIncomingCall(payload);
      }
    
      // Refresh notifications when new message arrives
      if (refreshNotifications) {
        refreshNotifications();
      }
    });

    return unsubscribe;
  }, [refreshNotifications]);

  const markAllAsRead = () => setUnreadCount(0);

  return (
    <FirebaseMessagingContext.Provider value={{ messages, unreadCount, markAllAsRead, setShowIncomingCallModal }}>
      {children}
    </FirebaseMessagingContext.Provider>
  );
};